<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      border
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:replenish="{ row }">
        <div>SPU:{{ row.replenishSpuCount }}</div>
        <div>SKU:{{ row.replenishSkuCount }}</div>
      </template>
      <template v-slot:reorder="{ row }">
        <div>SPU:{{ row.reorderSpuCount }}</div>
        <div>SKU:{{ row.reorderSkuCount }}</div>
      </template>
      <template v-slot:air="{ row }">
        <el-checkbox :checked="row.isAir == 'Y'" disabled></el-checkbox>
      </template>

      <template v-slot:fastShipping="{ row }">
        <el-checkbox
          :checked="row.isFastShipping == 'Y'"
          disabled
        ></el-checkbox>
      </template>

      <template v-slot:slowShipping="{ row }">
        <el-checkbox
          :checked="row.isSlowShipping == 'Y'"
          disabled
        ></el-checkbox>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    height() {
      const h = this.tableHeight - 336
      return h > 330 ? h : 330
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: white !important;
    border-color: #dcdfe6;
    cursor: not-allowed;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }
}
</style>
